<div class="ui modal advanced-filtering">
  <div class="ui header">Metric Filters</div>

  <div class="content">
    <p-message
      *ngIf="query?.rollup?.value !== 'total'"
      styleClass="metric-filter-info-message"
      [severity]="infoMessage[0].severity"
      [text]="infoMessage[0].detail"
      [closable]="false"
    />
    <metric-filters
      [datasetName]="datasetName"
      [schema]="schema"
      [compatibleMetrics]="compatibleMetrics"
      [filters]="filters"
      [filterOptions]="metricFilterOptions"
      [interval]="interval"
      [showDefaultFilter]="true"
      (filtersData)="updateFilters($event)"
    ></metric-filters>
  </div>
  <div class="tw-p-4 tw-flex tw-justify-end tw-gap-4 button-container">
    <p-button
      label="Cancel"
      severity="secondary"
      (click)="cancel()"
    ></p-button>

    <div>
      <p-button
        label="Add Filter {{ hasMetrics ? ' and Run Query' : '' }}"
        [disabled]="emptyFilterExists"
        (onClick)="applyFilters()"
      ></p-button>
    </div>
  </div>
</div>
